// =====================================================================
// Not-found page (T041).
//
// Rendered by the catch-all route in src/routes/index.js so an unknown
// path renders INSIDE the app shell (header + layout) instead of a blank
// white page. Reuses the shared presentational EmptyState tile rather
// than introducing another empty-state variant.
// =====================================================================
import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { EmptyState } from "../components/agency/v2/states";

const NotFound = () => (
  // min-h-full (not min-h-screen): PrivateLayout already owns the viewport
  // height; a second min-h-screen leaves a phantom page scrollbar.
  <div className="min-h-full w-full flex items-start justify-center px-4 py-16">
    <div className="w-full" style={{ maxWidth: 520 }}>
      <EmptyState
        icon={<Compass size={24} strokeWidth={1.8} color="#2563EB" />}
        title="Page not found"
        body="The page you are looking for does not exist or has been moved."
        bodyMaxWidth={400}
        cta={
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg bg-[#2563EB] px-4 py-2 text-[13.5px] font-semibold text-white hover:bg-[#1D4ED8]"
          >
            Go to Home
          </Link>
        }
      />
    </div>
  </div>
);

export default NotFound;
